"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Service
 * Provides OIDC and Security endpoints as well as CRUD operations for SAVE and E-Verify Users and Points of Contact.
 *
 * The version of the OpenAPI document: 3.0.35
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnexpiredAccountToJSON = exports.UnexpiredAccountFromJSONTyped = exports.UnexpiredAccountFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function UnexpiredAccountFromJSON(json) {
    return UnexpiredAccountFromJSONTyped(json, false);
}
exports.UnexpiredAccountFromJSON = UnexpiredAccountFromJSON;
function UnexpiredAccountFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'account': !runtime_1.exists(json, 'account') ? undefined : json['account'],
        'users': !runtime_1.exists(json, 'users') ? undefined : (json['users'].map(_1.UnexpiredUserFromJSON)),
    };
}
exports.UnexpiredAccountFromJSONTyped = UnexpiredAccountFromJSONTyped;
function UnexpiredAccountToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'account': value.account,
        'users': value.users === undefined ? undefined : (value.users.map(_1.UnexpiredUserToJSON)),
    };
}
exports.UnexpiredAccountToJSON = UnexpiredAccountToJSON;
